import container from "@/lib/di/container";
import { useEffect, useState } from "react";
import { FilterBar, FilterInputTemplate, FilterInputType } from "../../components/filter/FilterBar";
import { FilterSearchPayload, DataTable } from "../../components/table/DataTable";
import { DetailModal } from "./modals/DetailModal";
import { Button, message, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { formatDateTimePipe } from "@/core/pipes/format-date.pipe";
import { SampleTestModel, SampleTestModelFactory } from "@/core/models/sample-test.model";
import { SampleTestRepo } from "@/core/repos/tables/sample-test.repo";
import { suspensionStatusPipe } from "@/core/pipes/suspension-status.pipe";
import { DeleteButton } from "../../components/table/DeleteButton";
import { useTitleDataStore } from "@/core/stores/title-data.store";

const sampleTestRepo = container.get(SampleTestRepo);

export default function SampleTestPage() {
    const titleData = useTitleDataStore();
    const [modalData, setModalData] = useState<SampleTestModel>(SampleTestModelFactory.getEmpty())
    const [filterMap, setFilterMap] = useState<Map<string, FilterSearchPayload>>(new Map())
    const [selectedRows, setSelectedRows] = useState<SampleTestModel[]>([]);
    const [isDetailModal, setDetailModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [filterTemplates] = useState<FilterInputTemplate[]>([
        {
            dataIndex: "search",
            label: "Tìm kiếm",
            placeholder: "Nhập nội dung tìm kiếm",
            type: FilterInputType.text,
        },
    ])

    const showDetail = (record: SampleTestModel) => {
        setModalData(record);
        setDetailModal(true);
    };

    const init = async () => {
        titleData.setTitleActions({
            text: "Tạo Chất lượng nước",
            onPress: () => {
                showDetail(SampleTestModelFactory.getEmpty())
            }
        })
    }

    useEffect(()=>{init()}, []);

    const deleteSelected = async () => {
        setDeleting(true);
        const result = await sampleTestRepo.deleteMany(selectedRows);
        messageApi.success({
            content: `Bạn đã xoá thành công ${result.success}/${result.total} bản ghi`
        })
        setDeleting(false);
    }


    async function onFilterChange(map: Map<string, FilterSearchPayload>) {
        setFilterMap(new Map(map));
    }

    function onRowSelect(rows: SampleTestModel[]) {
        setSelectedRows([...rows]);
    }

    return (
    <div className="px-4 py-6">
        {contextHolder}
        <FilterBar setMap={setFilterMap} onChange={onFilterChange} templates={filterTemplates} map={filterMap} actions={[
            <div key={1} className="flex flex-row">
                <DeleteButton noGap loading={deleting} length={selectedRows.length} onConfirm={deleteSelected}/>
            </div>
        ]}/>
        <div className="mt-4 border-t border-dashed border-gray-300 pt-6">
            <DataTable<SampleTestModel>
                columns={[
                    { dataIndex: 'name', name: 'Tên' },
                    { dataIndex: 'sendDate', name: 'Ngày gửi mẫu', pipe: formatDateTimePipe},
                    { dataIndex: 'receiverResultDate', name: 'Ngày nhận kết quả', pipe: formatDateTimePipe},
                    { dataIndex: 'status', name: 'Hiển thị', pipe: suspensionStatusPipe },
                    {
                        name: 'Thao tác',
                        render: (_, record) => (
                            <div className="flex flex-row px-1 items-center justify-center">
                                <Tooltip className="mr-1" title="Sửa"><Button type="text" icon={<InfoCircleOutlined />} onClick={() => showDetail(record)}/></Tooltip>
                            </div>
                        ),
                        fixed: "right",
                        width: 50
                    },
                ]}
                repository={sampleTestRepo}
                filterMap={filterMap}
                onSelect={onRowSelect}
            ></DataTable>
        </div>
        <DetailModal isModalOpen={isDetailModal} setIsModalOpen={setDetailModal} data={modalData}></DetailModal>
    </div>)
}